module.exports = __webpack_public_path__ + "static/us_salmon_safe-857bc20987fc382575dffece9e9d0fe5.png";